import { InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import DropdownInput from "common/components/DropdownInput";
import { useTranslation } from "common/locales";
import { useCurrentFarmAnimalGroups } from "model";
import { classes, StyledFormControl } from "./fieldEditStyles";

interface AssignedToDropdownProps {
  assignedTo?: string;
  onChange: (value?: string) => void;
}

export default function AssignedToDropdown({
  assignedTo,
  onChange,
}: AssignedToDropdownProps) {
  const { t } = useTranslation();
  // Use proper React Query hook for animal groups
  const { data: animalGroups } = useCurrentFarmAnimalGroups();

  // If there is not a single animal group set up yet,
  // i.e. during initial farm setup, we do not want to
  // confuse users by showing the silage group only.
  if (animalGroups.length === 0) return null;

  return (
    <StyledFormControl className={classes.formControl}>
      <InputLabel id="assignedGroup-select-label" variant="standard">
        {t("fieldinput.assignedTo.text")}
      </InputLabel>
      <Select
        labelId="assignedGroup-select-label"
        id="assignedGroup-select"
        value={assignedTo ?? "silage"}
        onChange={onChangeSelect}
        input={<DropdownInput />}
      >
        <MenuItem value="silage" key="silage">
          {t("fieldinput.assignedTo.silage")}
        </MenuItem>
        {animalGroups.map((animalGroup) => (
          <MenuItem value={animalGroup.guid} key={animalGroup.guid}>
            {animalGroup.name}
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );

  function onChangeSelect(e: SelectChangeEvent<string>) {
    onChange(e.target.value === "silage" ? undefined : e.target.value);
  }
}
